import { YHistoryEditor, YjsEditor } from '@tunasong/sync-lib'

/**
 * Runs `edit` as an undo step of its own: one undo takes it out whole, and nothing else.
 *
 * A collaborative document's undo is a Y.js UndoManager (collab-yjs), which merges changes less than 500 ms apart
 * into one step. A command that inserts a block straight after the user typed would otherwise join the typing's
 * step, and its undo would take the typing too (melody toolkit M1, "one insert, one undo"; #2660).
 *
 * slate-yjs sends local edits to the Y.Doc on `onChange`, so the edits on either side are flushed before capturing
 * stops: what came before closes its step, and `edit` is closed before anything the user does next. An editor
 * without Y.js history runs `edit` as it is: slate-history does not merge an inserted node with the typing before it.
 */
export const asOwnUndoStep = (editor: object, edit: () => void) => {
  if (!YHistoryEditor.isYHistoryEditor(editor)) {
    edit()
    return
  }
  YjsEditor.flushLocalChanges(editor)
  editor.undoManager.stopCapturing()
  edit()
  YjsEditor.flushLocalChanges(editor)
  editor.undoManager.stopCapturing()
}
